import type { HelpdeskStatusGroup, HelpdeskZendeskStatus } from "@kuika/kuika-cl-model";
import classNames from "classnames";
import React from "react";
import { groupOf, statusLabel } from "./helpdesk-tickets";

export interface HelpdeskStatusBadgeProps {
  /** The ITSM's own status name, e.g. "İşlemde"; shown only as a hint. */
  status: string;
  statusGroup: HelpdeskStatusGroup;
  zendeskStatus: HelpdeskZendeskStatus;
}

/** Status pill; the testid (`openStatus` / `pendingStatus` / `solvedStatus`) matches the Zendesk viewer. */
const HelpdeskStatusBadge = ({ status, statusGroup, zendeskStatus }: HelpdeskStatusBadgeProps): React.ReactElement => {
  const group: string = groupOf(zendeskStatus);
  return (
    <span
      data-testid={`${group}Status`}
      title={status || undefined}
      className={classNames("kuika-helpdesk-status", `kuika-helpdesk-status--${group}`)}
    >
      {statusLabel(statusGroup, zendeskStatus)}
    </span>
  );
};

export default HelpdeskStatusBadge;
